import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "right",
  "use": "right-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"right\">\n    <path fill=\"#437dff\" fill-rule=\"evenodd\" d=\"M10.383 8.186c.087-.19.058-.423-.096-.576L6.8 4.136c-.19-.189-.49-.18-.67.02-.18.2-.172.516.018.706l3.13 3.117-3.117 3.163c-.189.191-.194.507-.013.705.093.102.217.153.341.153.119 0 .237-.047.33-.14l3.455-3.507c.007-.007.01-.017.016-.024l.016-.014c.027-.03.04-.066.06-.1.004-.01.012-.019.017-.03z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol